import { tns } from '../../vendor/tiny-slider/tiny-slider'

const blockList = document.querySelectorAll( '.block.testimonials' )
for( const block of blockList ) {

  const items = block.querySelector( ':scope > .content > .items' )
  const itemList = items.querySelectorAll( ':scope > .item' )
  const controls = block.querySelector( ':scope > .content > .controls' )
  const nav = block.querySelector( ':scope > .content > .nav' )

  if( itemList.length > 1 ) {
    tns( {
      container: items,
      loop: false,
      gutter: 32,
      items: 1,
      mouseDrag: true,
      controlsContainer: controls,
      navContainer: nav,
    } )
  }

}
